import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '姓名'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'sex',
    fieldName: '性别',
    url: 'Sex',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'email',
    fieldName: '邮箱'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '联系电话'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'post',
    fieldName: '岗位'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'dept',
    fieldName: '部门'
  }, {
    componentType: 'el-date-picker',
    componentName: '输入框',
    fieldKey: 'birthday',
    fieldName: '生日'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'address',
    fieldName: '省市县'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'addressDetail',
    fieldName: '详细地址'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'marketFlag',
    fieldName: '市场人员'
  },
  // {
  //   componentType: 'el-select',
  //   componentName: '输入框',
  //   fieldKey: 'taxIncluded',
  //   fieldName: '税前/税后',
  //   url: 'TaxType',
  //   selectType: 1,
  //   option: []
  // },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'rateType',
    fieldName: '费用计算方式'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '比例'
  }
]
